/** Extract a machine-readable error code from an API error, if present.
 *  Handles { code } and { error: { code } } response shapes. */
export function getErrorCode(error: unknown): string | undefined {
  if (error !== null && typeof error === 'object') {
    const err = error as Record<string, unknown>;
    const response = err.response as Record<string, unknown> | undefined;
    const data = (response?.data ?? err.data) as Record<string, unknown> | undefined;
    if (data && typeof data === 'object') {
      if (typeof data.code === 'string') return data.code;
      if (data.error && typeof data.error === 'object') {
        const nested = data.error as Record<string, unknown>;
        if (typeof nested.code === 'string') return nested.code;
      }
    }
  }
  return undefined;
}

export function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }
  
  // Handle Axios-like API error responses
  if (error !== null && typeof error === 'object') {
    const err = error as unknown as Record<string, unknown>;
    
    if (err.response && typeof err.response === 'object') {
      const response = err.response as unknown as Record<string, unknown>;
      if (response.data && typeof response.data === 'object') {
        const data = response.data as unknown as Record<string, unknown>;
        if (typeof data.message === 'string') {
          return data.message;
        }
        if (typeof data.error === 'string') {
          return data.error;
        }
        // Nested error object, e.g. { error: { code, message } }
        if (data.error && typeof data.error === 'object') {
          const nested = data.error as Record<string, unknown>;
          if (typeof nested.message === 'string') {
            return nested.message;
          }
        }
      }
    }
  }
  
  if (error instanceof Error) {
    if (error.message && error.message.startsWith('Request failed with status code')) {
      return '';
    }
    return error.message;
  }
  
  if (error !== null && typeof error === 'object') {
    const err = error as unknown as Record<string, unknown>;
    if (typeof err.message === 'string') {
      if (err.message.startsWith('Request failed with status code')) {
        return '';
      }
      return err.message;
    }
  }
  
  return 'An unknown error occurred';
}
